// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CONTINUOUS_CONTRACT_POSTFIX } from '@shared/utils/Enums/Constants';
import { InstrumentSpecificType } from '@shared/utils/Instruments/InstrumentSpecificType';
import { InstrumentUtils } from '@shared/utils/Instruments/InstrumentUtils';
export class SearchHelper {
    constructor(FullName) {
        if (!isValidString(FullName)) {
            return;
        }
        this.FullName = FullName;
        const splitedName = FullName.split(InstrumentUtils.SEPARATOR);
        if (splitedName.length !== 2) {
            return;
        }
        this.InstrumentTradableID = parseInt(splitedName[0].split(CONTINUOUS_CONTRACT_POSTFIX)[0]);
        this.Route = parseInt(splitedName[1]);
        const continuousSplit = splitedName[1].split('|');
        if (continuousSplit.length > 1) {
            this.Id = parseInt(continuousSplit[1]);
            this.InstrumentSpecificType = InstrumentSpecificType.ContinuousContract;
            this.FullName = this.FullName.replace('|' + this.Id, '');
        }
    }
    GetInteriorID() {
        return this.FullName;
    }
}
